import { Text } from '@react-pdf/renderer'
import Html from 'react-pdf-html'

import { applyInlineStylesToHTML, globalPDFStyles } from '../../styles'
import { MeasuresPDFProps } from '..'

export const MeasurePDFInstructions = ({ measureData }: MeasuresPDFProps) => {
  const styledHTML = applyInlineStylesToHTML(measureData?.instructions || '...')
  return (
    <>
      <Text style={globalPDFStyles.paragraphTitle}>Instructions</Text>
      <Html>{styledHTML}</Html>
    </>
  )
}
